import React from 'react';

import {useFormatNumber, I18nApi} from '@udemy/i18n';
import {type IconName} from '@udemy/icons';
import {TextSkeleton} from '@udemy/react-reveal-components';

export const calculateBenefits = (
    courseCount: number,
    isCollectionStatsLoading: boolean,
    i18n: I18nApi,
    formatNumber: ReturnType<typeof useFormatNumber>['formatNumber'],
): {icon: IconName; text: React.ReactNode}[] => {
    const {gettext, interpolate} = i18n;

    return [
        {
            icon: 'play' as const,
            text: isCollectionStatsLoading ? (
                <TextSkeleton lineCountPerParagraph={1} paragraphCount={1} />
            ) : (
                interpolate(
                    gettext(
                        '%(courses)s+ top-rated courses including AI, web development, data science, and IT',
                    ),
                    {courses: formatNumber(courseCount)},
                    true,
                )
            ),
        },
        {
            icon: 'sparkles' as const,
            text: gettext(
                'AI-powered soft skills practice through interactive role play scenarios',
            ),
        },
        {
            icon: 'code' as const,
            text: gettext('Hands-on technical practice through labs and coding exercises'),
        },
        {
            icon: 'gift' as const,
            text: gettext(
                'Comprehensive certification prep for AWS, Microsoft, CompTIA, PMI, and more',
            ),
        },
        {
            icon: 'info-outline' as const,
            text: gettext('Ad-free'),
        },
    ];
};
